// @ts-nocheck
import {ConfEnv} from "../../config/config";
import publicRequest from "../../Infra/http/public.request";

export const loginService = async (data: Record<string, unknown>) => {
  return publicRequest.post(ConfEnv.API_URL.URL_LOGIN, data);
};

export const recoverPasswordService = async (email: string) => {
  return publicRequest.post(`${ConfEnv.API_URL.URL_RECOVER_PASSWORD}/${encodeURIComponent(email)}`);
};
